<template>
  <div class="card" v-show="isSection('types')">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>あなたは何派？</h2>
      </div>
      <div class="card-content-list">
        <div
          class="myprofile-type-question"
          v-for="(q, i) in typeQuestions"
          :key="'type-' + q.id"
        >
          <p class="myprofile-type-label">{{ q.label }}</p>
          <div class="myprofile-type-options">
            <button
              type="button"
              v-for="opt in q.options"
              :key="opt"
              class="myprofile-type-card"
              :class="{ selected: typeValue(i) === opt }"
              @click="setType(i, opt)"
            >
              {{ opt }}
            </button>
          </div>
        </div>

        <div class="myprofile-form-group">
          <label class="myprofile-label">マイブームは？</label>
          <el-input v-model="myboom" placeholder="マイブームは？" />
        </div>
        <div class="myprofile-form-group">
          <label class="myprofile-label">休みの日は何してる？</label>
          <el-input v-model="holiday" placeholder="休みの日は何してる？" />
        </div>
        <div class="myprofile-form-group">
          <label class="myprofile-label">今欲しいものは？</label>
          <el-input v-model="wanted" placeholder="今欲しいものは？" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import typeQuestions from '@/utils/format-edit/myprofileTypeQuestions.json'
import {
  DEFAULT_MYPROFILE_TYPES,
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'

const props = defineProps<{
  currentCardId?: string
  formatId?: string
}>()

const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const myboom = computed({
  get: () => String(formatData.myboom ?? ''),
  set: (value: string) => {
    formatData.myboom = value
  }
})

const holiday = computed({
  get: () => String(formatData.holiday ?? ''),
  set: (value: string) => {
    formatData.holiday = value
  }
})

const wanted = computed({
  get: () => String(formatData.wanted ?? ''),
  set: (value: string) => {
    formatData.wanted = value
  }
})

function typeValue(idx: number) {
  return stringListItem(formatData.types, idx)
}

function setType(idx: number, val: string) {
  setStringListItem(
    formatData,
    'types',
    idx,
    val,
    DEFAULT_MYPROFILE_TYPES.length,
    DEFAULT_MYPROFILE_TYPES
  )
}
</script>

<style lang="scss" scoped>
.myprofile-form-group {
  margin-bottom: 16px;

  .myprofile-label {
    display: block;
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
    font-weight: bold;
  }
}

.myprofile-type-question {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .myprofile-type-label {
    flex: 0 0 auto;
    min-width: 72px;
    font-size: 14px;
    font-weight: bold;
  }

  .myprofile-type-options {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .myprofile-type-card {
    border: 2px solid #d9e7e4;
    background: #fff;
    border-radius: 10px;
    padding: 8px 18px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      border-color: #2fb9a3;
    }

    &.selected {
      border-color: #2fb9a3;
      background: #e6f7f3;
      color: #11806c;
      font-weight: bold;
    }
  }
}
</style>
